// extracted by mini-css-extract-plugin
export default {"cart":"TgCart_cart__4AP3Y","cart__G":"TgCart_cart__G__w05Un","cart__pol":"TgCart_cart__pol__9K0nf","cart__path":"TgCart_cart__path__KmPeb","cart__c":"TgCart_cart__c__UyE4+"};